module.exports = __webpack_public_path__ + "files/af1f9723d1df789516d9e3f4e44ef35f.png";